import Journey from "./Journey";

export default Journey;
